<h2 class="text-secondary mt-5 ms-5">{{ 'HOME.HEADING' | translate }}</h2>
<div class="row mt-7 mb-6">
  <div class="col mt-5 ms-5">
    <h2>{{ 'HOME.COMPANY' | translate }}</h2>
    <h3 *ngIf="organizationName">{{organizationName}}</h3>
    <h2>{{ 'HOME.COMPANY_ID' | translate }}</h2>
    <h3 *ngIf="organizationId">{{organizationId}}</h3>
  </div>
</div>
